if (!customElements.get('st-buy-return')) {
  customElements.define('st-buy-return', class extends HTMLElement {
    connectedCallback() {
      const form = document.getElementById(this.dataset.form);
      if (!form) return;
      // Only offer the shortcut after the native buying controls have scrolled away.
      // Scroll sampling also handles anchor jumps that skip past the entire form.
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.hidden = form.getBoundingClientRect().bottom >= 0;
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.onScroll();
      this.onClick = () => {
        const target = document.getElementById(this.dataset.target);
        if (!target) return;
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      };
      this.querySelector('a')?.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
      this.hidden = true;
      this.querySelector('a')?.removeEventListener('click', this.onClick);
    }
  });
}
